import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';

const EmptyDataPlaceHolder = () => {
  return (
    <Flex justify='center' mt='big'>
      <Flex
        items='end'
        pl='small'
        pr='small'
        pt='smaller'
        pb='smaller'
        backgroundColor={getColor('solitude')}
        borderRadius='3px'
        border={`1px solid ${getColor('frenchPass')}`}
      >
        <Icon name='InfoOutlined' color='azureRadius' />
        <Padding l='small'>
          <Text>No data to present. Try selecting a different time frame.</Text>
        </Padding>
      </Flex>
    </Flex>
  );
};

export default EmptyDataPlaceHolder;
